<template>
   <div class="offer-callback-container"></div>
</template>

<script>
import { confirmOffer } from "@/service/global.api.js";
import Popup from "@/gts-popup.js";

export default {
   name: "OfferCallback",
   data() {
      return {
         uuid: null,
      };
   },
   mounted() {
      this.uuid = this.$route.query.uuid;
      if (this.uuid) {
         this.callConfirmOffer();
      }
   },
   methods: {
      callConfirmOffer() {
         this.$store.commit("app/setIsProgressGifActive", true);
         this.$store.state.app.progress.message = this.$i18n.t("offerCallback_lblRedirectInformationMsg");
         confirmOffer({ offerUuid: this.uuid }).then((response) => {
            this.$store.commit("app/setIsProgressGifActive", false);

            if (response?.result?.success === false) {
               Popup.result(response.result);
            } else if (response?.redirectPath) {
               // eslint-disable-next-line no-debugger
               debugger;
               this.$router.push(response.redirectPath);
            }
         });
      },
   },
};
</script>

<style scoped>
.offer-callback-container {
   padding: 20px;
}
</style>
